/**
 * Public links use a scoped token supplied in the URL.  It must never become
 * the application's login token: it is only attached to requests made while
 * the public scoped route is active.
 */
export function getScopedToken(route) {
  if (!route || !route.matched || !route.matched.some(record => record.meta.publicScopedToken)) {
    return null
  }

  const token = route.query && route.query['scoped-token']
  return Array.isArray(token) ? token[0] : token
}

export function isScopedTokenRoute(route) {
  return Boolean(getScopedToken(route))
}

export function applyScopedToken(config, route) {
  const scopedToken = getScopedToken(route)

  if (!scopedToken) {
    return false
  }

  config.headers = config.headers || {}
  delete config.headers.token
  delete config.headers.Authorization

  if (config.headers.common) {
    delete config.headers.common.token
    delete config.headers.common.Authorization
  }

  config.headers['scoped-token'] = scopedToken
  return true
}
